// extracted by mini-css-extract-plugin
export default {"subtitle":"titles_subtitle__Z9CCM","subtitleItem":"titles_subtitleItem__wmLPX"};